/*
 * created by ex_huozh 2020-11-20
 * 工具类
 */
function getUID () {
    // get UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function generateStamp () {
    const nowTime = new Date();
    let month = nowTime.getMonth() + 1;
    month = month < 10 ? '0' + month : '' + month;
    let date = nowTime.getDate();
    date = date < 10 ? '0' + date : '' + date;
    let hour = nowTime.getHours();
    hour = hour < 10 ? '0' + hour : '' + hour;
    let minite = nowTime.getMinutes();
    minite = minite < 10 ? '0' + minite : '' + minite;
    let second = nowTime.getSeconds();
    second = second < 10 ? '0' + second : '' + second;
    return '' + nowTime.getFullYear() + month + date + hour + minite + second;
}

function getQueryString (key) {
    // key存在先通过search取值如果取不到就通过hash来取
    let after = window.location.search.substr(1) || window.location.hash.split('?')[1];
    if (after) {
        if (!after.includes(key)) {
            // 微信分享带参数的链接，做特殊处理
            after = window.location.hash.split('?')[1];
            if (!after) {
                // 无自带参数
                return null;
            }
        }
        const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
        const r = after.match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        } else {
            return null;
        }
    } else {
        return null;
    }
}
function getParams () {
    let params = window.location.search.substr(1) || window.location.hash.split('?')[1];
    if (params === '') {
        return null;
    }
    if (params) {
        if (params.includes('from')) {
            // 微信分享带参数的链接，做特殊处理
            params = window.location.hash.split('?')[1];
        }
    }
    return params;
}
function toNum (a) {
    a = a.toString();
    const c = a.split('.');
    const numPlace = ['', '0', '00', '000', '0000'];
    const r = numPlace.reverse();
    for (let i = 0; i < c.length; i++) {
        const len = c[i].length;
        c[i] = r[len] + c[i];
    }
    const res = c.join('');
    return res;
}
function formatDate (date) {
    const d = new Date(date);
    let mm = d.getMinutes();
    mm = mm < 10 ? '0' + mm : mm;
    return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日' + d.getHours() + ':' + mm;
}
function isAndroid () {
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) {
        return true;
    } else {
        return false;
    }
}
function isAndroid5 () {
    if (isAndroid()) {
        const ua = navigator.userAgent.toLowerCase();
        const index = ua.indexOf('android');
        if (index >= 0) {
            let androidVersion = parseFloat(ua.slice(index + 8));
            androidVersion += '';
            if (androidVersion.indexOf('.') !== -1) {
                androidVersion = androidVersion.substring(0, androidVersion.indexOf('.'));
            }
            console.log('Android大版本号=' + androidVersion);
            if (androidVersion < 5) {
                return true;
            }
        }
    }
    return false;
}
function isIos () {
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
        return true;
    } else {
        return false;
    }
}

function isIOS10 () {
    if (isIos()) {
        // 获取固件版本
        const getOsv = function () {
            const reg = /OS ((\d+_?){2,3})\s/;
            if (
                navigator.userAgent.match(/iPad/i) ||
                navigator.platform.match(/iPad/i) ||
                navigator.userAgent.match(/iP(hone|od)/i) ||
                navigator.platform.match(/iP(hone|od)/i)
            ) {
                const osv = reg.exec(navigator.userAgent);
                if (osv.length > 0) {
                    return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
                }
            }
            return '';
        };
        const osv = getOsv();
        const osvArr = osv.split('.');
        if (osvArr && osvArr.length > 0) {
            console.log('iOS大版本号=' + parseInt(osvArr[0]));
            if (parseInt(osvArr[0]) < 10) {
                return true;
            }
        }
    }
    return false;
}
function iPhoneXcompatible () {
    const userAgent = window.navigator.userAgent;
    const devicePixelRatio = window.devicePixelRatio;
    const width = window.screen.width;
    const height = window.screen.height;
    // iPhone X、iPhone XS
    const isIPhoneX =
        /iphone/gi.test(userAgent) && devicePixelRatio && devicePixelRatio === 3 && width === 375 && height === 812;
    // iPhone XS Max
    const isIPhoneXSMax =
        /iphone/gi.test(userAgent) && devicePixelRatio && devicePixelRatio === 3 && width === 414 && height === 896;
    // iPhone XR
    const isIPhoneXR =
        /iphone/gi.test(userAgent) && devicePixelRatio && devicePixelRatio === 2 && width === 414 && height === 896;
    if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        return true;
    } else {
        return false;
    }
}

function toApp (targetUrl, downloadUrl) {
    console.log('[aCallAPP1]' + targetUrl);
    /* eslint-disable-next-line */
    let timeout;
    timeout && clearTimeout(timeout);
    const ev =
        'visibilitychange' in window
            ? 'visibilitychange'
            : 'webkitvisibilitychange' in window
                ? 'webkitvisibilitychange'
                : 'mozvisibilitychange ';
    document.addEventListener(ev, function () {
        const tag = document.hidden || document.webkitHidden;
        if (tag) {
            clearTimeout(timeout);
        }
    });

    document.addEventListener('visibilitychange', function () {
        // 微信上document.hidden不生效，要用document.visibilityState判断
        if (document.visibilityState === 'hidden') {
            clearTimeout(timeout);
        }
    });

    window.addEventListener('pagehide', function () {
        clearTimeout(timeout);
    });
    const t = Date.now();
    const interval = 2000;
    timeout = setTimeout(function () {
        if (Date.now() - t < interval + 1000) {
            console.log('[aCallAPP2]' + downloadUrl);
            location.href = downloadUrl;
        }
    }, interval);
    window.location.href = targetUrl;
}

function isFacebookApp () {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
}

function isMSmartLife() {
    return !(/smartiolife/i.test(location.href) || /tsmart/i.test(location.href));
}

function masBaseURL() {
    const base = {
        MSmartHome: {
            sit: 'https://mp-us-sit.appsmb.com/mas/v5/app/proxy?alias=',
            prod: 'https://mp-prod.appsmb.com/mas/v5/app/proxy?alias='
        },
        TSmartLife: {
            sit: 'https://mp-jp-sit.appsmb.com/mas/v5/app/proxy?alias=',
            prod: 'https://mp-jp-prod.appsmb.com/mas/v5/app/proxy?alias='
        }
    };
    const env = window.location.href.match(/sit|:80\d\d/) ? 'sit' : 'prod';

    return isMSmartLife() ? base.MSmartHome[env] : base.TSmartLife[env];
}

export {
    getUID,
    generateStamp,
    getQueryString,
    getParams,
    toNum,
    formatDate,
    isAndroid,
    isIos,
    isAndroid5,
    isIOS10,
    iPhoneXcompatible,
    toApp,
    isFacebookApp,
    isMSmartLife,
    masBaseURL
};
